import { useNavigate } from "react-router";

import { ROUTE_NAMES } from "../../../../constants";

import { ScenarioModelingHeaderExtra } from "./ScenarioModelingHeaderExtra";
import { ForecastHeaderExtra } from "./ForecastHeaderExtra";
import {
  HeaderExtraBackgroundFormat,
  HeaderExtraBrokerSettingsIcon,
} from "./HeaderExtraFormat";

interface Props {
  data: { estimatedBonus: string; bonusGoal: string; totalBobPremium: string };
  brokerId: string;
  route: string;
  selectedModelId?: string;
}

function HeaderExtra({
  data,
  brokerId,
  route,
  selectedModelId = "",
}: Props): React.JSX.Element {
  const navigate = useNavigate();
  const isBonusForecastRoute = route === ROUTE_NAMES.BBE_FORECAST;
  const isScenarioModelingRoute = route === ROUTE_NAMES.BBE_SCENARIO_MODELING;

  const navigateToBrokerSettingPage = (): void => {
    navigate(
      `/${ROUTE_NAMES.BBE}/${brokerId}/${ROUTE_NAMES.BBE_FORECAST}/${ROUTE_NAMES.BBE_BROKER_SETTINGS}`,
    );
  };

  if (isBonusForecastRoute)
    return (
      <ForecastHeaderExtra
        data={data}
        navigateToBrokerSettingPage={navigateToBrokerSettingPage}
      />
    );

  if (isScenarioModelingRoute)
    return (
      <ScenarioModelingHeaderExtra
        brokerId={brokerId}
        selectedModelId={selectedModelId}
        navigateToBrokerSettingPage={navigateToBrokerSettingPage}
      />
    );

  return (
    <HeaderExtraBackgroundFormat>
      <HeaderExtraBrokerSettingsIcon
        navigateToBrokerSettingPage={navigateToBrokerSettingPage}
      />
    </HeaderExtraBackgroundFormat>
  );
}

export { HeaderExtra };
